module.exports = __webpack_public_path__ + "static/picture2-dea47c4793f768288b8dc47f4b48967b.png";